module.exports = __webpack_public_path__ + "static/media/anatomia.8fd2ed00.png";